import {get} from '../../utils'
import makeUrl from './makeUrl';

const url = (host, id) => makeUrl(host)(id)

export default host => id => get(url(host, id))
  .then(response => response.blob())
  .then(blob => URL.createObjectURL(blob))